export const QUERY_TYPE = {
  BY_TEST: 'BY_TEST',
  BY_TOPIC: 'BY_TOPIC',
};
